import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

import { useAppDispatch, useAppSelector } from "@/reduxHooks";
import { closeModal } from "@/slices/modal-slice";

import ExpandedPromptBody from "./expanded-prompt-body";

const ExpandedPromptModal = () => {
  const dispatch = useAppDispatch();
  const { modalProps } = useAppSelector((state) => state.rootReducer.modals);

  const onClose = () => {
    if (modalProps?.onCloseFn) {
      modalProps.onCloseFn();
    }
    dispatch(closeModal());
  };
  return (
    <Modal isOpen={true} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent className="overflow-hidden max-h-[80vh]">
        <ModalHeader>Prompt</ModalHeader>
        <ModalCloseButton mr={0}/>
        <ModalBody className="max-h-[70vh] overflow-y-auto">
          <ExpandedPromptBody />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ExpandedPromptModal;
